// extracted by css-extract-rspack-plugin
export default {"image":"FileListGalleryItemThumbnail_image__Z3G4j"};